import {NgModule, Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { SharedPipeChatModule } from '../../shared/shared.pipe.chat.module';
import { ArraySortModule } from '../../shared/shared.pipe.sort';
import { HttpService } from '../../services/http.service';
import { UserInfoModule } from '../../components/userInfo';


@Component({
    selector: 'connector-friends-list',
    template: `
        <!-- chat_box -->
        <div class="chat_box">
            <div class="chat_list scroll" [ngStyle]="{height: (dynamicHeight) + 'px'}" >
                <div class="mem_list">
                    <ul>
                        <li *ngFor="let v of connector | arraySort: 'online': 'asc'">
                            <mat-icon svgIcon="dot" class="dot-icon pt6 mat-icon-12" aria-label="off line" [ngClass]="{'on': v.online === true}">dot</mat-icon>
                            <user-info [mbid]="v.mb_id">
                                <img [src]="'assets/images/common/lv/' + v.mb_level + '.png'" alt="" class="lvS1" /><em>{{v.mb_nick}}</em>
                            </user-info>
                        </li>
                        <li class="data_none" *ngIf="!connectorSize">
                            <i class="xi-info-o"></i> 친구 리스트가 없습니다.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `
})

export class ConnFriendsComponent {
    // showNum = 0;
    data: any = {message: ''};
    dynamicHeight = 300;
    connector = [];
    connectorSize = 0;

    @Input() set resizeObject(resizeData: {edges: any, rectangle: any }) {
        if (!resizeData.rectangle) {
            return;
        }

        this.dynamicHeight = resizeData.rectangle.height - 78;
    }

    @Input() set selectedChatIndex(index: number) {
        if (index === 2) {
            this.get_friend_list();

            /* 5초마다 한번식 현재 접속자를 갱신한다. **/
            // $timeout(function() {
                // this.get_friend_list();
            // }, 5000);
        }
    }
    constructor(private http: HttpService) { // private injector: Injector
        // this.showNum = this.injector.get('showNum');
    }

    private get_friend_list() {
        this.http.get({url: 'mypage/friends-with-connection'}).then((obj) => {
            this.connector = obj.data;
            this.connectorSize = Object.keys(obj.data).length;
        });
    }

}

@NgModule({
    declarations: [ ConnFriendsComponent ],
    imports: [ CommonModule, FormsModule, MatIconModule, SharedPipeChatModule, UserInfoModule, ArraySortModule],
    exports: [ ConnFriendsComponent ]
})

export class ConnFriendsModule {}
